import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import classnames from 'classnames';

export default function VoicemailRow({ invoice, onResend }) {
  /* Event Handlers */
  const onResendClick = (event) => {
    event.preventDefault();

    onResend(invoice);
  };

  // Use currency code to set symbol
  let currencySymbol = invoice.amount.code;
  if (invoice.amount.code === 'USD') {
    currencySymbol = '$';
  }

  // Contents of resend element
  let resendEmail = (<a href="" onClick={onResendClick}>Resend</a>);
  if (invoice.isEmailSentSuccess === true) {
    resendEmail = 'Email sent';
  } else if (invoice.isEmailSentFail === true) {
    resendEmail = 'Failed';
  }

  const isPending = invoice.payment_status !== 'paid';

  return (
    <tr className={classnames({ unread: isPending })}>
      <td>
        {moment(invoice.create_date, 'YYYY-MM-DD HH:mm:ss').startOf('month').subtract(1, 'M').format('MMMM YYYY')}
      </td>
      <td>
        {moment(invoice.create_date, 'YYYY-MM-DD HH:mm:ss').add(1, 'd').format('Do MMMM YYYY')}
      </td>
      <td>{currencySymbol}{invoice.amount.amount}</td>
      <td>
        {
          invoice.v3_status === 'paid' ?
            'Paid' :
            'Unpaid'
        }
      </td>
      <td className="hide">
        {resendEmail}
      </td>
      <td className="hide">
        <a
          href={`${window.Config.API_URL}/accounts/invoice?id=${invoice.invoiceid}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Download
        </a>
      </td>
    </tr>
  );
}

VoicemailRow.defaultProps = {
  onResend: () => {},
  invoice: {
    created_at: '',
    due_date: '',
    amount: {
      amount: 0,
      code: 'USD',
    },
    payment_status: '',
  },
};

VoicemailRow.propTypes = {
  onResend: PropTypes.func,
  invoice: PropTypes.shape({
    created_at: PropTypes.string,
    due_date: PropTypes.string,
    amount: PropTypes.object,
    payment_status: PropTypes.string,
  }),
};
